/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const ModelBoolean = {
  T: "T",
  F: "F",
} as const;

export type ModelBoolean = (typeof ModelBoolean)[keyof typeof ModelBoolean];

export type ModelBooleanEnumType = typeof ModelBoolean;
export type ModelBooleanOptional = ModelBoolean;
export type ModelBooleanTrackedI = ModelBoolean;
export type ModelBooleanTracked = ModelBoolean;
export type ModelBooleanMetaI = EnumMetaType<
  ModelBooleanEnumType,
  ModelBoolean
>;
export const ModelBooleanMeta = typeMetaEnum<
  ModelBooleanEnumType,
  ModelBoolean
>("ModelBoolean", ModelBoolean);
export function transformDatesModelBoolean(model: ModelBoolean) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
